import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import Orders from './Orders';
import { Indicator } from './piluMobile/Indicator';
import { PieChartDash } from './PieChartDash';
import { Alert, Autocomplete, Button, Stack } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import {
	gridButtonStyle,
	gridStyle,
	SelectComponent,
	stackStyle,
} from '../../orders/SummaryResults';
import { LoadingButton } from '@mui/lab';
import { getPiluMobileStats } from '../../../actions/appointments';
import { DIVISIONS } from '../../utils/lists';
import { getDashboardMobileReport } from '../../../actions/dashboard';
import { getTodayDate } from '../../../helpers/hours';

function Copyright() {
	return (
		<Typography variant='body2' color='textSecondary' align='center'>
			<Link
				color='inherit'
				href='https://datagram-software.vercel.app/'
				target='_blank'
			>
				Datagram
			</Link>{' '}
			{' - '}
			<Link
				color='inherit'
				href='https://piluniformes.com.mx/'
				target='_blank'
			>
				Pilu
			</Link>{' '}
			{new Date().getFullYear()}.
		</Typography>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		width: '100%',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
		display: 'flex',
		overflow: 'none',
		flexDirection: 'column',
	},
	fixedHeight: {
		height: 240,
	},
	fixedHeightIndicator: {
		height: 150,
	},
	fixedHeightMedium: {
		height: 285,
	},
	fixedHeightLarger: {
		height: 500,
	},
}));

export const DashboardMobile = () => {
	// Date state
	const [date1, setDate1] = useState(getTodayDate(0, true));
	const [date2, setDate2] = useState(getTodayDate(0, false));
	const [division, setDivision] = useState(null);

	// Is loading
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingDownload, setIsLoadingDownload] = useState(false);

	// States
	const [data, setData] = useState(null);

	const classes = useStyles();

	const fixedHeightPaperIndicator = clsx(
		classes.paper,
		classes.fixedHeightIndicator
	);

	const fixedHeightPaperMedium = clsx(
		classes.paper,
		classes.fixedHeightMedium
	);

	// Handle Reset
	const handleReset = () => {
		setDate1(null);
		setDate2(null);
		setDivision(null);
	};

	const formatIndicators = (_data) => {
		let newIndicators = [];
		for (const key in _data.indicators) {
			newIndicators.push({
				name: key,
				value: _data.indicators[key],
			});
		}

		newIndicators = [
			...newIndicators,
			{
				name: 'totalEvents',
				value: _data['totalEvents'],
			},
			{
				name: 'fullToComplete',
				value: _data['fullToComplete'],
			},
			{
				name: 'dayRate',
				value: _data['dayRate'],
			},
		];

		return newIndicators;
	};

	const formatUsers = (users) => {
		return users?.map((user) => ({
			col1: user?.display_name,
			col2: user?.completionRate + '%',
			col3: user?.division,
			col4: user?.area,
			col5: user?.email,
		}));
	};

	const formatCars = (cars) => {
		return cars?.map((car) => ({
			col1: car?.carType,
			col2: car?.count,
		}));
	};

	const formatBusyWorkers = (busyWorkers) => {
		return busyWorkers?.map((car) => ({
			col1: car?.display_name,
		}));
	};

	const handleGetData = () => {
		// Get Pilu mobile statistics from Datagram API
		getPiluMobileStats(date1, date2, division ?? null).then(({ data }) => {
			setData(data);
		});
	};

	const getExcelReport = async () => {
		await getDashboardMobileReport(data);
	};

	useEffect(() => {
		handleGetData();
	}, []);

	return (
		<div className={classes.root}>
			{data ? (
				<main>
					<Stack
						direction='row'
						alignItems='flex-end'
						justifyContent='space-between'
						style={stackStyle}
					>
						<Typography
							variant='h4'
							color='textSecondary'
							align='center'
							style={{ margin: '0 0 3rem 2rem' }}
						>
							Indicadores de citas
						</Typography>
						{/* <h4>Indicadores de citas</h4> */}
						<LocalizationProvider
							dateAdapter={AdapterDateFns}
							adapterLocale={es}
							utils={DateFnsUtils}
						>
							<Grid container spacing={1} style={gridStyle}>
								<Grid item xs={3}>
									{/* Date 1 */}
									<DesktopDatePicker
										style={{ width: '50%' }}
										label='Desde'
										inputFormat='dd/MM/yyyy'
										value={date1}
										onChange={(val) => {
											setDate1(val);
										}}
										renderInput={(params) =>
											SelectComponent(params, 'Desde')
										}
									/>
								</Grid>
								<Grid item xs={3}>
									{/* Date 2 */}
									<DesktopDatePicker
										style={{ width: '50%' }}
										label='Desde'
										inputFormat='dd/MM/yyyy'
										value={date2}
										onChange={(val) => {
											setDate2(val);
										}}
										renderInput={(params) =>
											SelectComponent(params, 'Hasta')
										}
									/>
								</Grid>

								<Grid item xs={3}>
									<Autocomplete
										required
										// style={{ marginTop: '-17px' }}
										fullWidth
										value={division}
										onChange={(_, value) => {
											setDivision(value);
										}}
										options={DIVISIONS.map(
											(item) => item.label
										)}
										renderInput={(params) =>
											SelectComponent(params, 'División')
										}
									/>
								</Grid>
								{/* {date1 !== null && date2 !== null && ( */}
								<Grid
									item
									xs={
										5 //date1 !== null && date2 !== null ? 5 : 2
									}
									style={gridButtonStyle}
								>
									<>
										<Button
											variant='contained'
											color='error'
											onClick={handleReset}
											style={{ margin: '0 15px 0 0' }}
										>
											Limpiar
										</Button>

										<LoadingButton
											variant='contained'
											color='success'
											onClick={getExcelReport}
											loading={isLoading}
											style={{ margin: '0 15px 0 0' }}
										>
											Descargar
										</LoadingButton>

										<LoadingButton
											variant='contained'
											color='primary'
											onClick={handleGetData}
											loading={isLoading}
											style={{ margin: '0 15px 0 0' }}
										>
											Obtener
										</LoadingButton>

										{false && (
											<LoadingButton
												variant='contained'
												color='success'
												// onClick={handleGetResultsExcel}
												loading={isLoadingDownload}
												disabled={
													date1 === null ||
													date2 === null
												}
											>
												Exportar
											</LoadingButton>
										)}
									</>
								</Grid>
								{/* )} */}
							</Grid>
						</LocalizationProvider>
					</Stack>

					<Container maxWidth='lg' className={classes.container}>
						<Grid container spacing={3}>
							{/* Indicators */}
							{formatIndicators(data).map(({ name, value }) => (
								<Grid item xs={3} key={name}>
									<Paper
										className={fixedHeightPaperIndicator}
									>
										<Indicator name={name} value={value} />
									</Paper>
								</Grid>
							))}

							{/* Sectors */}
							<Grid item xs={7}>
								<Typography
									variant='h4'
									color='textSecondary'
									align='left'
									style={{ margin: '0 0 15px 0' }}
								>
									Sectores
								</Typography>
								{data?.sectorCompletionStats?.length > 6 ? (
									<>
										<Grid item xs={12}>
											<Paper
												className={
													fixedHeightPaperMedium
												}
											>
												{/* <Chart data={data?.amounts} /> */}
												<PieChartDash
													data={data?.sectorCompletionStats?.slice(
														0,
														7
													)}
												/>
											</Paper>
										</Grid>
										<Grid item xs={12}>
											<Paper
												className={
													fixedHeightPaperMedium
												}
											>
												{/* <Chart data={data?.amounts} /> */}
												<PieChartDash
													data={data?.sectorCompletionStats?.slice(
														7,
														data
															?.sectorCompletionStats
															?.length - 1
													)}
												/>
											</Paper>
										</Grid>
									</>
								) : data?.sectorCompletionStats?.length <= 5 ? (
									<Grid item xs={12}>
										<Paper
											className={fixedHeightPaperMedium}
										>
											{/* <Chart data={data?.amounts} /> */}
											<PieChartDash
												data={
													data?.sectorCompletionStats
												}
											/>
										</Paper>
									</Grid>
								) : (
									<Typography
										variant='h6'
										color='textSecondary'
										align='left'
										style={{ margin: '0 0 15px 0' }}
									>
										No hay información al momento
									</Typography>
								)}
							</Grid>

							{/* Event time distributions */}
							<Grid item xs={5}>
								<Grid item xs={12}>
									<Typography
										variant='h4'
										color='textSecondary'
										align='left'
										style={{ margin: '0 0 15px 0' }}
									>
										Distribución de eventos en el día
									</Typography>
								</Grid>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
									}}
								>
									<Grid
										item
										xs={4}
										style={{ margin: '0 10px 0 0' }}
									>
										<Paper
											className={clsx(classes.paper, 100)}
										>
											<Indicator
												name='Mañana'
												value={
													data?.eventTimeDistribution
														?.length > 0
														? data
																?.eventTimeDistribution[0]
																?.eventCount
														: 0
												}
												icon='morning'
												subtitle='Desde las 5 am a las 11 am'
												noCursor
											/>
										</Paper>
									</Grid>
									<Grid
										item
										xs={4}
										style={{ margin: '0 10px 0 0' }}
									>
										<Paper
											className={clsx(classes.paper, 100)}
										>
											<Indicator
												name='Tarde'
												value={
													data?.eventTimeDistribution
														?.length > 0
														? data
																?.eventTimeDistribution[1]
																?.eventCount
														: 0
												}
												icon='afternoon'
												subtitle='Desde las 12 pm a las 4 pm'
												noCursor
											/>
										</Paper>
									</Grid>
									<Grid
										item
										xs={4}
										style={{ margin: '0 10px 0 0' }}
									>
										<Paper
											className={clsx(classes.paper, 100)}
										>
											<Indicator
												name='Noche'
												value={
													data?.eventTimeDistribution
														?.length > 0
														? data
																?.eventTimeDistribution[2]
																?.eventCount
														: 0
												}
												icon='evening'
												subtitle='Desde las 5 pm a las 11 pm'
												noCursor
											/>
										</Paper>
									</Grid>
								</div>
							</Grid>

							{data?.usersRates?.length > 0 && (
								<Grid item xs={8}>
									<Paper className={classes.paper}>
										<Orders
											name='Rendimiento de los asesores'
											// link
											columns={[
												'Nombre',
												'Rendimiento',
												'División',
												'Área',
												'Correo',
											]}
											rows={formatUsers(data?.usersRates)}
										/>
									</Paper>
								</Grid>
							)}
							<Grid item xs={4}>
								<Grid container spacing={3}>
									{data?.counterCars?.length > 0 && (
										<Grid item xs={12}>
											<Paper
												className={classes.paper}
												style={{ marginBottom: '15px' }}
											>
												<Orders
													name='Automóviles'
													columns={[
														'Modelo',
														'En uso',
													]}
													rows={formatCars(
														data?.counterCars
													)}
												/>
											</Paper>
										</Grid>
									)}

									{data?.workersCounts?.busyWorkers?.length >
										0 && (
										<Grid item xs={12}>
											<Paper
												className={classes.paper}
												style={{ marginBottom: '15px' }}
											>
												<Orders
													name='Trabajadores ocupados'
													columns={['Nombre']}
													rows={formatBusyWorkers(
														data?.workersCounts
															?.busyWorkers
													)}
												/>
											</Paper>
										</Grid>
									)}

									{data?.workersCounts?.notBusyWorkers
										?.length > 0 && (
										<Grid item xs={12}>
											<Paper
												className={classes.paper}
												style={{ marginBottom: '15px' }}
											>
												<Orders
													name='Trabajadores disponibles'
													columns={['Nombre']}
													rows={formatBusyWorkers(
														data?.workersCounts
															?.notBusyWorkers
													)}
												/>
											</Paper>
										</Grid>
									)}
								</Grid>
							</Grid>
						</Grid>
						<Box pt={4}>
							<Copyright />
						</Box>
					</Container>
				</main>
			) : (
				<div style={{ padding: '20px' }}>
					<Alert severity='info'>
						Cargando y procesando información...
					</Alert>
				</div>
			)}
		</div>
	);
};
